import { __awaiter, __generator } from "tslib";
import superagent from 'superagent';
import { readCookie, removeCookie, writeCookie } from '../utils/cookies';
export var ACCESS_TOKEN = 'AccessTokenCMS';
export function getBaseUrl(folder) {
    if (folder === void 0) { folder = 'admin'; }
    if (location.host.indexOf('localhost') !== -1) {
        return "http://localhost:3000/api/v1/" + folder + "/";
    }
    else {
        return (process.env.REACT_APP_API_BASE_URL || 'https://wondadviseur.appec.nl/') + "api/v1/" + folder + "/";
    }
}
export function getImageUrl(fileName) {
    var base = '';
    if (location.host.indexOf('localhost') !== -1) {
        base = "http://localhost:3000/images/";
    }
    else {
        base = (process.env.REACT_APP_API_BASE_URL || 'https://wondadviseur.appec.nl/') + "images/";
    }
    return base + fileName;
}
export var EndPoints;
(function (EndPoints) {
    EndPoints["login"] = "login/";
    EndPoints["users"] = "users/";
    EndPoints["usersCreate"] = "users/create/";
    EndPoints["usersUpdate"] = "users/update/";
    EndPoints["usersDelete"] = "users/delete";
    EndPoints["config"] = "config/";
    EndPoints["configUpdate"] = "config/update/";
    EndPoints["products"] = "products/";
    EndPoints["productsCreate"] = "products/create/";
    EndPoints["productsUpdate"] = "products/update/";
    EndPoints["productsDelete"] = "products/delete/";
    EndPoints["groups"] = "groups/";
    EndPoints["groupsCreate"] = "groups/create/";
    EndPoints["groupsUpdate"] = "groups/update/";
    EndPoints["groupsDelete"] = "groups/delete/";
    EndPoints["push"] = "push/";
    EndPoints["pushSend"] = "push/send/";
    EndPoints["pushDelete"] = "push/delete/";
    EndPoints["wounds"] = "wounds/";
    EndPoints["woundsCreate"] = "wounds/create/";
    EndPoints["woundsUpdate"] = "wounds/update/";
    EndPoints["woundsDelete"] = "wounds/delete/";
    EndPoints["homeWounds"] = "homeWounds/";
    EndPoints["homeWoundsCreate"] = "homeWounds/create/";
    EndPoints["homeWoundsUpdate"] = "homeWounds/update/";
    EndPoints["homeWoundsDelete"] = "homeWounds/delete/";
    EndPoints["upload"] = "upload/";
    EndPoints["medias"] = "medias/";
    EndPoints["mediasDelete"] = "medias/delete/";
    EndPoints["models"] = "models/";
    EndPoints["modelsCreate"] = "models/create/";
    EndPoints["modelsUpdate"] = "models/update/";
    EndPoints["modelsDelete"] = "models/delete/";
    EndPoints["hygienes"] = "hygienes/";
    EndPoints["hygienesCreate"] = "hygienes/create/";
    EndPoints["hygienesUpdate"] = "hygienes/update/";
    EndPoints["hygienesDelete"] = "hygienes/delete/";
    EndPoints["extras"] = "extras/";
    EndPoints["extrasCreate"] = "extras/create/";
    EndPoints["extrasUpdate"] = "extras/update/";
    EndPoints["extrasDelete"] = "extras/delete/";
})(EndPoints || (EndPoints = {}));
export var UploadType;
(function (UploadType) {
    UploadType["wound"] = "wound";
    UploadType["product"] = "product";
    UploadType["generic"] = "generic";
    UploadType["vision"] = "vision";
    UploadType["photo"] = "photo";
    UploadType["group"] = "group";
    UploadType["extra"] = "extra";
    UploadType["hygiene"] = "hygienes";
})(UploadType || (UploadType = {}));
export function checkIfLogged() {
    return readCookie(ACCESS_TOKEN) !== null;
}
export function setAuthToken(token) {
    writeCookie(ACCESS_TOKEN, token, 365);
}
export function getAuthToken() {
    return readCookie(ACCESS_TOKEN) || '';
}
export function getAuthHeader() {
    return {
        'Authorization': 'Bearer ' + getAuthToken(),
        'Language': 'nl',
    };
}
export function post(endPoint, data) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, superagent
                    .post(getBaseUrl() + endPoint + 'index.php')
                    .set('Content-Type', 'application/json')
                    .set(getAuthHeader())
                    .send(data)
                    .accept('application/json')
                    .then(function (result) {
                    if (result.body.data && result.body.data.error) {
                        if (result.body.data.error.code === 401) {
                            removeCookie(ACCESS_TOKEN);
                            window.location = window.location.pathname;
                        }
                        else {
                            throw result.body.data.error.message;
                        }
                    }
                    return result.body.data;
                })];
        });
    });
}
export function patch(endPoint, data) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, superagent
                    .patch(getBaseUrl() + endPoint + 'index.php')
                    .set('Content-Type', 'application/json')
                    .set(getAuthHeader())
                    .send(data)
                    .accept('application/json')
                    .then(function (result) {
                    if (result.body.data && result.body.data.error) {
                        if (result.body.data.error.code === 401) {
                            removeCookie(ACCESS_TOKEN);
                            window.location = window.location.pathname;
                        }
                        else {
                            throw result.body.data.error.message;
                        }
                    }
                    return result.body.data;
                })];
        });
    });
}
export function get(endPoint, data) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, superagent
                    .get(getBaseUrl() + endPoint + 'index.php')
                    .set('Content-Type', 'application/json')
                    .set(getAuthHeader())
                    .query(data)
                    .accept('application/json')
                    .then(function (result) {
                    if (result.body.data && result.body.data.error) {
                        if (result.body.data.error.code === 401) {
                            removeCookie(ACCESS_TOKEN);
                            window.location = window.location.pathname;
                        }
                        else {
                            throw result.body.data.error.message;
                        }
                    }
                    return result.body.data;
                })];
        });
    });
}
export function del(endPoint, data) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, superagent
                    .delete(getBaseUrl() + endPoint + 'index.php')
                    .set('Content-Type', 'application/json')
                    .set(getAuthHeader())
                    .send(data)
                    .accept('application/json')
                    .then(function (result) {
                    if (result.body.data && result.body.data.error) {
                        if (result.body.data.error.code === 401) {
                            removeCookie(ACCESS_TOKEN);
                            window.location = window.location.pathname;
                        }
                        else {
                            throw result.body.data.error.message;
                        }
                    }
                    return result.body.data;
                })];
        });
    });
}
